import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: ({ backgroundImage }) => ({
    color: theme.palette.secondary.contrastText,
    background: backgroundImage?.url ? `url(${backgroundImage.url}) no-repeat` : 'none',
    backgroundSize: 'cover',
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
  }),
  backgroundOverlay: {
    backgroundColor: 'rgba(0, 35, 75, 0.9)',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  content: {
    position: 'relative',
    zIndex: 1,
  },
  eventCardContainer: ({ wrap }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(6),
    flexWrap: 'nowrap',
    gap: '1rem',
    [theme.breakpoints.down('lg')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      display: !wrap ? 'none' : 'flex',
      gap: '3rem',
    },
  }),
  centered: {
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      justifyContent: 'center !important',
    },
    '& $logos': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  supportText: {
    marginTop: theme.spacing(3),
  },
  eventCard: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1rem',
    marginRight: '1rem',
    maxWidth: '276px',
    '&:first-child': {
      marginLeft: '0',
    },
    '&:last-child': {
      marginRight: '0',
    },
    [theme.breakpoints.up('lg')]: {
      marginRight: '0',
    },
  },
  textContainer: {
    '&>div>div': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      marginBottom: '0 !important',
    },
    '&>div>div>a': {
      color: 'white',
      boxShadow: 'rgb(255, 255, 255) 0px 1px 0px',
      '&:hover': {
        color: 'white',
      },
    },
  },
  description: {
    lineHeight: '1.5rem',
  },
  logos: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%',
    marginBottom: theme.spacing(2),
  },
  arrow: {
    width: '100px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    color: theme.palette.secondary.contrastText,
    padding: 0,
    '&:hover': {
      color: theme.palette.secondary.contrastText,
    },
  },
  yearTitleContainer: {
    marginBottom: '1rem',
  },
  sliderContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'center',
    justifyContent: 'flex-start',
  },
  slider: ({ wrap }) => ({
    display: 'none',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(6),
      display: !wrap ? 'block' : 'none',
      width: '100%',
    },
  }),
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  titleTextWrapper: {
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  ctaButton: {
    backgroundColor: theme.palette.accent.main,
    color: 'black',
    '&:hover': {
      backgroundColor: 'theme.palette.accent.main !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(6),
    },
  },
  richTextWrapper: {
    '& div.rich-paragraph': {
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        lineHeight: '1.75rem',
      },
    },
  },
}))

export default useStyles
